import { FaShoppingCart, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";

import { useCart } from "../../../context/CartContext";

import "./StickyCartBar.css";

export default function StickyCartBar() {

  const navigate = useNavigate();

  const {
    cartItems,
    totals,
  } = useCart();

  // ==========================================
  // Hide when cart is empty
  // ==========================================

  if (!cartItems || cartItems.length === 0) {
    return null;
  }

  // ==========================================
  // Sticky Cart UI
  // ==========================================

  const cartBar = (

    <div
      className="sticky-cart-bar"
      onClick={() => navigate("/cart")}
      role="button"
      tabIndex={0}
    >

      <div className="sticky-cart-left">

        <FaShoppingCart className="cart-icon" />

        <div>

          <h4>
            {totals.totalItems} Item
            {totals.totalItems > 1 ? "s" : ""}
          </h4>

          <p>
            ₹{totals.grandTotal}
          </p>

        </div>

      </div>


      <div className="sticky-cart-right">

        <span>
          View Cart
        </span>

        <FaArrowRight />

      </div>

    </div>

  );

  // ==========================================
  // Render directly into BODY
  // ==========================================

  return createPortal(
    cartBar,
    document.body
  );

}